import { RecentPacketData } from '@/types';
import { useNavigate } from 'react-router-dom';
import { cn } from "@/lib/utils";
import { UserInfo } from "@/components/common/UserInfo";
import { StatusBadge } from '@/components/ui/StatusBadge';
import { AttemptBadge } from '@/components/ui/attempt-badge';

interface RecentPacketItemProps {
  packet: RecentPacketData;
  index?: number;
}

export function RecentPacketItem({ packet, index }: RecentPacketItemProps) {
  const navigate = useNavigate();

  const handleItemClick = () => {
    navigate(`/packets/${packet.id}`);
  };

  return (
    <div
      className={cn(
        'flex items-center justify-between p-5 cursor-pointer transition-colors duration-150 ease-in-out',
        index !== undefined && index % 2 !== 0 ? 'bg-gray-100' : '',
        'hover:bg-muted/50'
      )}
      onClick={handleItemClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleItemClick();
        }
      }}
    >
      <div className="flex items-center gap-4">
        <UserInfo
          initials={packet.initials}
          name={packet.candidateName}
          currentTitle={packet.candidateTitle}
        />
        {packet.attempt && packet.attempt > 1 ? (
          <AttemptBadge attempt={packet.attempt} />
        ) : null}
      </div>
      <StatusBadge status={packet.status} className="capitalize" />
    </div>
  );
} 